import config from '../config'
import { ColorOptionList } from '../config/config.type'
// colormap for every language
// TODO: replace colorMap with better solution (e.g. algolia)

type ColorMapInformation = {
  borderColor: string
  svg: string
}

type ColorMapType = {
  [K in (typeof ColorOptionList)[number]]: ColorMapInformation
}

const colorMap: ColorMapType = {
  white: {
    borderColor: '#A4A4A4',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/6ec6b7/971c26/70fe96/6f5ca9/b397f5/61/6ec6b7971c2670fe966f5ca9b397f561.svg'
  },
  black: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/1877f0/de4cf0/b754b7/970691/af0281/59/1877f0de4cf0b754b7970691af028159.svg'
  },
  grey: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/7a5bb7/c25cac/3f037b/313ac2/ef358e/0b/7a5bb7c25cac3f037b313ac2ef358e0b.svg'
  },
  silver: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/117a8c/e534b1/d208ac/9cfaa3/23bd8f/60/117a8ce534b1d208ac9cfaa323bd8f60.svg'
  },
  brown: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/744f7c/d15a85/3af900/9d4a58/1dad59/db/744f7cd15a853af9009d4a581dad59db.svg'
  },
  blue: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/9523c3/6ff8bf/e6b863/26bf19/35ca44/5f/9523c36ff8bfe6b86326bf1935ca445f.svg'
  },
  multicolor: {
    borderColor: '#A4A4A4',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/f823b1/486f3b/b0abb4/f19448/2f0166/97/f823b1486f3bb0abb4f194482f016697.svg'
  },
  red: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/76a5d2/1a9207/fd1e16/ed866c/b994d6/22/76a5d21a9207fd1e16ed866cb994d622.svg'
  },
  beige: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/085346/868320/845cc1/baaf63/ea2918/0c/085346868320845cc1baaf63ea29180c.svg'
  },
  green: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/469c88/05e530/7edd5b/aefc25/f73176/14/469c8805e5307edd5baefc25f7317614.svg'
  },
  transparent: {
    borderColor: '#A4A4A4',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/0b0efc/d3418f/e7aaa1/283759/aeaa84/d5/0b0efcd3418fe7aaa1283759aeaa84d5.svg'
  },
  lilac: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/023aef/f37418/561509/92d805/70945b/51/023aeff3741856150992d80570945b51.svg'
  },
  orange: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/847ec0/170d27/3d3cde/c204b9/30eb1e/7f/847ec0170d273d3cdec204b930eb1e7f.svg'
  },
  yellow: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/924cfb/040110/b3ed4c/7f6f83/65fd2d/fb/924cfb040110b3ed4c7f6f8365fd2dfb.svg'
  },
  gold: {
    borderColor: '#fff',
    svg:
      config.modules.cloudinary.endpoint +
      'pim/a268da/838b76/926141/0e7221/c24a31/8e/a268da838b769261410e7221c24a318e.svg'
  }
}

export default colorMap
